import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import flagsmith from 'flagsmith';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  private initPromise: Promise<void> | null = null;
  private currentIdentity: string | null = null;

  private ensureInitialized(identity?: string): Promise<void> {
    if (!environment.flagsmithEnvironmentId) {
      return Promise.reject(new Error('Flagsmith environment ID não configurado.'));
    }

    if (!this.initPromise) {
      this.initPromise = new Promise<void>((resolve) => {
        flagsmith.init({
          environmentID: environment.flagsmithEnvironmentId,
          identity: identity || undefined,
          onChange: () => {
            resolve();
          }
        });
      });
      this.currentIdentity = identity ?? null;
    } else if (identity && identity !== this.currentIdentity) {
      // Troca de identidade (customerId)
      this.initPromise = this.initPromise.then(() => flagsmith.identify(identity)).then(() => {
        this.currentIdentity = identity;
      });
    }

    return this.initPromise;
  }

  async identify(customerId: string, traits?: Record<string, any>): Promise<void> {
    await this.ensureInitialized();
    await flagsmith.identify(customerId, traits);
    this.currentIdentity = customerId;
  }

  private async refresh(customerId?: string): Promise<void> {
    await this.ensureInitialized();
    if (customerId) {
      if (this.currentIdentity !== customerId) {
        await flagsmith.identify(customerId);
        this.currentIdentity = customerId;
      } else {
        if (typeof (flagsmith as any).getFlags === 'function') {
          await (flagsmith as any).getFlags();
        } else {
          // Fallback: re-identify para forçar refetch
          await flagsmith.identify(customerId);
        }
      }
    } else {
      if (typeof (flagsmith as any).getFlags === 'function') {
        await (flagsmith as any).getFlags();
      } else {
        // Fallback: alterna para anônimo
        await flagsmith.logout();
      }
    }
  }

  async hasFeature(flagName: string, customerId?: string): Promise<boolean> {
    await this.refresh(customerId);
    return flagsmith.hasFeature(flagName);
  }

  async getValue(flagName: string, customerId?: string): Promise<string | null> {
    await this.refresh(customerId);
    const value = flagsmith.getValue(flagName);
    return value === undefined ? null : String(value);
  }
}


